import { useContext } from "react";
import APIContext from "@/context/API";

const useAPI = () => {
  const apiContext = useContext(APIContext);
  if (!apiContext) {
    throw new Error("useAPI must be used within an APIProvider");
  }
  return apiContext;
};

export default useAPI;
